import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';

import ChangesItem from './ChangesItem';

const PIDChangesModal = () => {
  const { engineStore } = useStores();
  const [isPIDChangesModalOpen, setPIDChangesModalOpen] = useState(engineStore.hasPIDChanges || engineStore.hasKpiChanges);
  const { t } = useTranslation();

  useEffect(() => {
    setPIDChangesModalOpen(engineStore.hasPIDChanges || engineStore.hasKpiChanges);
  }, [engineStore.hasPIDChanges, engineStore.hasKpiChanges]);

  const closePIDChangesModal = () => {
    setPIDChangesModalOpen(false);
  };

  const message = engineStore.hasKpiChanges && engineStore.hasPIDChanges ? t('kpiChangesAndPIDChanges') : engineStore.hasKpiChanges ? t('kpiChanges') : t('pidChanges');
  
  return (
    <Modal
      open={isPIDChangesModalOpen}
      footer={null}
      onCancel={closePIDChangesModal}
      centered
      width={600}
      style={{ paddingRight: 30, paddingLeft: 30 }}
    >
      <div>{message}</div>
      <ChangesItem title="compressorsAdded" items={engineStore.pidChanges?.compressorsAdded} />
      <ChangesItem title="compressorsRemoved" items={engineStore.pidChanges?.compressorsRemoved} />
      <ChangesItem title="flowKPIModified" items={engineStore.pidChanges?.flowSensorsRemoved} />
      <ChangesItem title="pressureKPIModified" items={engineStore.pidChanges?.pressureSensorsRemoved} />
      <ChangesItem title="compressorPriorityChangedToIgnore" items={engineStore.pidChanges?.compressorPriorityChangedToIgnore} />
      <ChangesItem title="compressorPriorityChangedFromIgnore" items={engineStore.pidChanges?.compressorPriorityChangedFromIgnore} />
    </Modal>
  );
};

export default PIDChangesModal;
